import React from 'react';
import {useAuth} from "../contexts/AuthContext";
import LoadingSpinner from "../components/common/LoadingSpinner";
import {Navigate, Outlet, useLocation} from "react-router-dom";
import {RoutePaths} from "../config/routeConstants";
import {useUser} from "../contexts/UserContext";
import {USER_ROLES} from "../models/users.models";

const AdminPanelGuard = () => {
    const {isAuthenticated, isAdmin, isVerifying} = useAuth();
    const {isLoadingUser, user} = useUser();
    const location = useLocation();

    if (isVerifying || isLoadingUser) return <LoadingSpinner/>;

    if (!isAuthenticated || !user) return <Navigate to={RoutePaths.Login} replace state={{from: location}} />;

    if (!isAdmin || user.role !== USER_ROLES.SYSTEM_ADMIN) return <Navigate to={RoutePaths.Chat} replace />;

    return <Outlet/>;
};

export default AdminPanelGuard;